class VariantUpsell extends HTMLElement {
  constructor() {
    super();
    this.handleVariantChange = this.handleVariantChange.bind(this);
  }

  connectedCallback() {
    this.init();
    document.addEventListener('variant:changed', this.handleVariantChange);
  }

  disconnectedCallback() {
    // Clean up event listeners if the element is removed from the DOM
    document.removeEventListener('variant:changed', this.handleVariantChange);
  }

  init() {
    this.script = this.querySelector('script');
    this.variantJson = JSON.parse(this.script.innerText);
    this.checkbox = this.querySelector('input[type="checkbox"]');
    this.label = this.querySelector('.variant-upsell__label');
  }

  handleVariantChange(evt) {
    const variant = evt.detail.variant;
    const variantUpsell = this.variantJson[variant.id];

    if (variantUpsell && variantUpsell.id !== null) {
      this.checkbox.checked = false;
      this.checkbox.value = variantUpsell.id;
      this.label.innerText = variantUpsell.label;
    }
  }
}

customElements.define('variant-upsell', VariantUpsell);
